import './index.css';

export default {
  name: 'Asnow',
  props: {
    id: { type: String, default: () => (`a-snow-${Math.random().toString().substring(2)}`) },
    size: { type: Number | String, default: () => 8 }, // 雪花大小
    speed: { type: Number | String, default: () => 5 }, // 滚动速度(值越小越快)
    count: { type: Number | String, default: () => 50 }, // 雪花总数
    reverse: { type: Boolean, default: () => false }, // 是否反转
    dynamic: { type: Boolean, default: () => true }, // 是否更新
    opacity: { type: Number | String, default: () => 0.5 }, // 最小透明度
  },
  data() {
    return ({
      width: null, // 容器宽度
      height: null, // 容器高度
      interval: null, // 更新间隔
      container: null, // 容器对象
      animationName: (`${this.id}-item`), // 动画名字
    });
  },
  mounted() {
    this.create();
  },
  destroyed() {
    this.revoke();
  },
  computed: {
    style() {
      return (`
        <style>
          @keyframes ${this.animationName} {
            ${this.reverse ? ('10% { opacity: 1 } 50% { opacity: 0 }') : ('50% { opacity: 1 } 90% { opacity: 0 }')}
            100% { opacity: 0; transform: translateY(${this.reverse ? -this.height : this.height}px) }
          }
        </style>
      `);
    },
  },
  methods: {
    create() {
      this.$nextTick(() => {
        !this.width && (this.width = this.$el.clientWidth);
        !this.height && (this.height = this.$el.clientHeight);
        this.$nextTick(() => {
          this.$el.innerHTML += this.style;
          this.$nextTick(() => {
            !this.container && (this.container = this.$el.querySelector('.a-snow-body'));
            if (this.container) {
              for (let a = 0; a < parseInt(this.count); a++) this.append();
              this.$nextTick(() => this.dynamic && (this.update()));
            }
          });
        });
      });
    },
    append() {
      const item = document.createElement('i');
      const x = (Math.random() * this.width);
      const size = ((Math.random() * 5) + parseInt(this.size));
      const speed = parseInt(this.speed);
      item.style.transform = (`translateY(${this.reverse ? this.height : -(size * 2)}px)`);
      item.style.left = (`${x}px`);
      item.style.width = (`${size}px`);
      item.style.height = (`${size}px`);
      item.style.animationDuration = (`${((Math.random() * (speed / 2)) + (speed / 2))}s`);
      item.style.animationDelay = (`${(Math.random() * (speed * 2))}s`);
      item.style.animationName = this.animationName;
      item.className = ('a-snow-item');
      this.$nextTick(() => {
        const icon = document.createElement('i');
        icon.style.animationDuration = (`${(Math.random() + 1)}s`);
        icon.style.animationDelay = (`${(Math.random() * 5)}s`);
        icon.style.opacity = Math.max(((Math.random() * 0.7) + 0.3), Number(this.opacity));
        icon.className = ('a-snow-icon');
        item.appendChild(icon);
        this.$nextTick(() => this.container && this.container.appendChild(item));
      });
    },
    remove() {
      this.container && this.container.removeChild(this.container.firstChild);
    },
    update() {
      if (this.interval) {
        clearInterval(this.interval);
        this.interval = null;
      } else {
        this.interval = setInterval(() => {
          const first = this.container.firstChild;
          if (first && first.firstChild) {
            first.firstChild.style.opacity = 0;
          }
          this.$nextTick(() => {
            let timeout = null;
            if (timeout) {
              clearTimeout(timeout);
              timeout = null;
            } else {
              this.$nextTick(() => timeout = setTimeout(() => {
                this.remove();
                this.$nextTick(() => this.append());
                clearTimeout(timeout);
                timeout = null;
              }, 300));
            }
          });
        }, (parseInt(this.speed) * 100));
      }
    },
    revoke() {
      if (this.interval) {
        clearInterval(this.interval);
        this.interval = null;
      }
      this.width = null;
      this.height = null;
      this.$nextTick(() => {
        this.container = null;
        this.$nextTick(() => this.$el.innerHTML = null);
      });
    },
  },
  render() {
    const { padding, margin, width = '100%', height = '100%', background } = this.$attrs;
    return (
      <div class="a-snow" id={this.id} style={{ padding, margin, width, height, background }}>
        <div class="a-snow-body" style={{ width: (`${this.width}px`), height: (`${this.height}px`) }} />
        {this.$slots.default && (<div class="a-snow-core">{this.$slots.default}</div>)}
      </div>
    );
  }
}